module.exports = __webpack_public_path__ + "img/project.d816ca63.svg";